import { createSelector } from 'reselect';
import { VoyagerAttributes } from '../interfaces/voyagerLeads';
import { StoreState } from '../store-interfaces';

export const selectVoyagerFilterAttributes = (state: StoreState) =>
  state.voyagerLeads.attributes;

export const selectVoyagerLeads = (state: StoreState) =>
  state.voyagerLeads.contacts.records;

export const selectVoyagerLeadsCount = (state: StoreState) =>
  state.voyagerLeads.contacts.total;

const sortFilterAttributes = (attributes: VoyagerAttributes[]) =>
  attributes.sort((a, b) => {
    if (a.attribute < b.attribute) {
      return -1;
    }
    if (a.attribute > b.attribute) {
      return 1;
    }
    return 0;
  });

export const voyagerAttributesSortedSelector = createSelector(
  [selectVoyagerFilterAttributes],
  sortFilterAttributes,
);
